<template>
  <div class="ai-example">
    <div class="title">平台用例</div>
    <div class="box">
      <img class="center-img" src="../assets/images/center-icon.png"/>
      <div class="item data-source">
        <div class="item-text" style="margin-right: 25px">
          <p class="label">数据源</p>
          <p class="content">开提供多种数据源接入方式，也可将原始数据一键导入到平台</p>
        </div>
        <img class="item-img" src="../assets/images/datasource.png"/>
      </div>
      <div class="item pretreatment">
        <div class="item-text" style="margin-right: 25px">
          <p class="label">数据预处理</p>
          <p class="content2">支持对原始数据在线清洗脏数据，提供现在标注工具</p>
        </div>
        <img class="item-img" src="../assets/images/pretreatment.png"/>
      </div>
      <div class="item model-develop">
        <div class="item-text" style="margin-right: 25px">
          <p class="label">模型开发</p>
          <p class="content">提供开箱即用的AI训练环境以及融合的Mlab在线开发工具</p>
        </div>
        <img class="item-img" src="../assets/images/modeldevelop.png"/>
      </div>
      <div class="item model-training">
        <img class="item-img" src="../assets/images/modeltraining.png"/>
        <div class="item-text" style="margin-left: 25px">
          <p class="label">模型训练</p>
          <p class="content">提供AI训练任务对模型进行训练，支持深度学习分布式训练，可视化部署训练作业</p>
        </div>
      </div>
      <div class="item model-manage">
        <img class="item-img" src="../assets/images/modelmanage.png"/>
        <div class="item-text" style="margin-left: 25px">
          <p class="label">模型管理</p>
          <p class="content2">平台模型管理系统管理训练好的模型，支持多版本管理，下载，分享等功能</p>
        </div>
      </div>
      <div class="item deploy-service">
        <img class="item-img" src="../assets/images/deployservice.png"/>
        <div class="item-text" style="margin-left: 25px">
          <p class="label">部署服务</p>
          <p class="content">将模型发布为AI服务，通过部署到PaaS平台提供AI能力或者将模型部署至边缘平台</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
	export default {
		name: 'AiExample',
	}
</script>

<style>
	.ai-example {
		height: 824px;
    background-image: url("../assets/images/aiexample.png");
    position: relative;
	}

	.ai-example .title {
    width: 120px;
    height: 34px;
    font-size: 30px;
    font-weight: 500;
    color: #333333;
    line-height: 34px;
    margin: 110px auto 0;
    display: inline-block;
	}

	.ai-example .box {
	}

	.ai-example .box .center-img {
		margin: 83px auto 0;
	}

  .ai-example .box .item {
    width: 454px;
    display: flex;
    align-items: start;
    justify-content: space-between;
  }
  .ai-example .box .data-source {
    text-align: right;
    position: absolute;
    top: 26%;
    right: calc(50% + 125px);
  }
  .ai-example .box .pretreatment {
    text-align: right;
    position: absolute;
    top: 51%;
    right: calc(50% + 250px);
  }
  .ai-example .box .model-develop {
    text-align: right;
    position: absolute;
    top: 74%;
    right: calc(50% + 125px);
  }
  .ai-example .box .model-training {
    text-align: left;
    position: absolute;
    top: 26%;
    left: calc(50% + 125px);
  }
  .ai-example .box .model-manage {
    text-align: left;
    position: absolute;
    top: 51%;
    left: calc(50% + 250px);
  }
  .ai-example .box .deploy-service {
    text-align: left;
    position: absolute;
    top: 74%;
    left: calc(50% + 125px);
  }
  .ai-example .box .item-text .label {
    height: 26px;
    font-size: 26px;
    font-weight: 500;
    color: #333333;
    line-height: 26px;
  }
  .ai-example .box .item-text .content {
    width: 353px;
    height: 52px;
    font-size: 16px;
    font-weight: 400;
    color: #333333;
    line-height: 26px;
    margin-top: 20px;
    opacity: 0.7;
  }
  .ai-example .box .item-text .content2 {
    width: 343px;
    height: 52px;
    font-size: 16px;
    font-weight: 400;
    color: #333333;
    line-height: 26px;
    margin-top: 20px;
    opacity: 0.7;
  }
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/AiExample.vue